const Interaction = () => {
  return <></>;
};

export default Interaction;
